import { useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';
import { Seller } from '@shopify-multiseller/graphql/partner/types';
import { SELLER_QUERY } from '../context/queries';
import { useAuthenticatedUser } from '../context/AuthenticatedUserProvider';

export const useSellerRefresh = (options?: { skipInitialRefresh?: boolean }) => {
  const authenticatedUser = useAuthenticatedUser();
  const [getSeller, { loading, error }] = useLazyQuery<{
    seller: Seller
  }>(SELLER_QUERY, {
    fetchPolicy: 'no-cache',
    onError: (error) => {
      console.error('Failed to refresh seller:', error);
    }
  });

  const refreshSeller = async (): Promise<void> => {
    try {
      const { data } = await getSeller();
      if (data?.seller && authenticatedUser.user) {
        const currentSeller = authenticatedUser.user.seller;
        if (JSON.stringify(currentSeller) !== JSON.stringify(data.seller)) {
          authenticatedUser.updateUser({ 
            ...authenticatedUser.user, 
            seller: data.seller 
          });
        }
      } else {
        console.log('No seller data returned from refresh');
      }
    } catch (error) {
      console.error('Failed to refresh seller:', error);
    }
  };

  const userIdentity = authenticatedUser.user?.username;

  useEffect(() => {
    if (!options?.skipInitialRefresh && userIdentity) {
      void refreshSeller();
    }
  }, [userIdentity]);

  return {
    refreshSeller,
    loading,
    error
  };
}; 